export enum CompanyType {
  InternalTest = 'Internal Test',
  None = 'None',
  Other = 'Other',
  Partner = 'Partner',
  PayingCustomer = 'Paying Customer',
  Trial = 'Trial',
}
